export enum TipoEnderecoEnum {

  Correspondencia,
  Localizacao
}
